module.exports = __webpack_public_path__ + "img/pro_two_5.5e81dfdb.jpg";